import { render } from "./bookcaseSpace.vue?vue&type=template&id=06663fb2&scoped=true"
import script from "./bookcaseSpace.vue?vue&type=script&lang=js"
export * from "./bookcaseSpace.vue?vue&type=script&lang=js"

import "./bookcaseSpace.vue?vue&type=style&index=0&id=06663fb2&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06663fb2"]])

export default __exports__